import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const RESPONSIBLE_QUERY = gql`
  query responsibleList {
    responsibleList {
      id
      name
    }
  }
`;

export const QUOTES_QUERY = gql`
  query quotes(
    $page: Int!
    $pageSize: Int!
    $freeTxt: String
    $responsibleId: Int
    $requiredById: Int
    $orderBy: String
  ) {
    quotes(
      page: $page
      pageSize: $pageSize
      freeTxt: $freeTxt
      responsibleId: $responsibleId
      requiredById: $requiredById
      orderBy: $orderBy
    ) {
      page
      pageSize
      totalCount
      totalPages
      values {
        ...listQuoteItem
      }
    }
  }
  ${Fragments.listQuoteItem}
`;

export const LIST_QUOTE_ITEM_QUERY = gql`
  query listQuoteItem($quoteId: Int!) {
    listQuoteItem(quoteId: $quoteId) {
      ...listQuoteItem
    }
  }
  ${Fragments.listQuoteItem}
`;

export const DELETE_QUOTE_QUERY = gql`
  query deleteQuote($quoteId: Int!) {
    deleteQuote(quoteId: $quoteId)
  }
`;

export const BROWSER_LIST_QUOTE_ITEM_QUERY = gql`
  query ListQuoteItem($quoteId: Int!) {
    listQuoteItem(quoteId: $quoteId) {
      ...listQuoteItem
    }
  }
  ${Fragments.listQuoteItem}
`;

export const QUOTE_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      quoteId
      quoteStatusId
      assetNo
      isEstimation
    }
  }
`;
